// components/ApplyModal.js
import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, Label, Input } from 'reactstrap';
import FloatingInput from '../components/Input';
import { post } from '../utils/apiUtil';
import { useNavigate } from 'react-router-dom';

const ApplyModal = ({ isOpen, toggle, job }) => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const [formData, setFormData] = useState({
        ID: 0,
        fullName: '',
        emailAddress: '',
        phoneNumber: '',
        password: '',
    });

    useEffect(() => {
        if (job?.ID) {
            setFormData((prevData) => ({
                ...prevData,
                ID: job.ID
            }));
        }
    }, [job?.ID]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const formDataToSend = new FormData();
        formDataToSend.append('fullName', formData.fullName);
        formDataToSend.append('emailAddress', formData.emailAddress);
        formDataToSend.append('phoneNumber', formData.phoneNumber);
        formDataToSend.append('ID', formData.ID);
        formDataToSend.append('resume', formData.resume); // file input

        try {
            const response = await post('/apply-for-job', formDataToSend);
            if (response.status === 200) {
                alert('Your application has been forwarded to the concerned department.');
                navigate('/thank-you');
            } else {
                throw new Error(response?.data?.message || "Submission failed.");
            }
        } catch (error) {
            alert(error.message);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <form onSubmit={handleSubmit}>
                <ModalBody className="modal-body p-5">
                    <div className="text-center mb-4">
                        <h5 className="modal-title">Apply for <span className='text-primary'>{job?.jobDescription || job?.JobTitle}</span></h5>
                    </div>
                    <div className="position-absolute end-0 top-0 p-3">
                        <button
                            type="button"
                            onClick={toggle}
                            className="btn-close"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="mb-3">
                        <FloatingInput
                            name="fullName"
                            label="Full name"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <FloatingInput
                            name="emailAddress"
                            label="Email address"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <FloatingInput
                            name="phoneNumber"
                            label="Phone number"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <Label className="form-label fs-11" for="inputGroupFile01">
                            Upload your updated resume.
                        </Label>
                        <Input
                            type="file"
                            className="form-control"
                            id="inputGroupFile01"
                            onChange={(e) => setFormData({ ...formData, resume: e.target.files[0] })}
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? 'Please wait.' : 'Send application'}
                    </button>
                </ModalBody>
            </form>
        </Modal>
    );
};

export default ApplyModal;
